import { Container, EstadoInfo, EstadoTexto, Porcentagem } from './styles';

interface EstadoCardProps {
  ranking: number;
  estado: string;
  quantidade: string;
  porcentagem: string;
  isEstado?: boolean;
}

export function EstadoCardComponent({ ranking, estado, quantidade, porcentagem, isEstado }: EstadoCardProps) {
  return (
    <Container isEstado={isEstado}>
      <EstadoTexto>
        <strong>{ranking}º</strong>
        <EstadoInfo>
          <strong>{estado}</strong>
          <p>{quantidade}</p>
        </EstadoInfo>
      </EstadoTexto>
      <Porcentagem>
        <p>{porcentagem}%</p>
      </Porcentagem>
    </Container>
  );
}
